import { render, staticRenderFns } from "./DocSecret.vue?vue&type=template&id=3b69c647&"
import script from "./DocSecret.vue?vue&type=script&lang=js&"
export * from "./DocSecret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports